<template>
    <div>
        <div class="container my-5 contenedor-tramites"> 
            <h6 class="subtitulo mb-2 textoFijo">Manual de servicios de la Secretaría de Hacienda</h6>
            <div class="lineaNegra"></div>
            <div class="mt-1 mb-4 lineaNegra2"></div>
            <p class="subtitulo2">Busca aqui información de trámites</p>
            <div class="caja_busqueda">
                <!-- AREA DEL SELECT -->
                <select class="js-example-basic-single" id="miCombo">
                    <option>Cargando...</option>
                </select> 
                <router-link v-bind:to="'/cedula-servicio2/'+idTramite+'/token='+token">
                    <button @click="consultarTramite" class="btn btn-vino btn-lupa"><i class="fas fa-search icono-lupa"></i></button>
                </router-link>
            </div>

            <!-- ==============Area de botones del abecedario==================== -->
            <div class="btn-toolbar horizontal-scroll-contenedor my-3" role="toolbar" aria-label="Toolbar with button groups">
                <div class="btn-group mr-2" role="group" aria-label="First group">
                    <button type="button" @click="buscarLetra('A')" class="btn btn-vino-light mr-1">A</button>
                    <button type="button" @click="buscarLetra('B')" class="btn btn-vino-light mr-1">B</button>
                    <button type="button" @click="buscarLetra('C')" class="btn btn-vino-light mr-1">C</button>
                    <button type="button" @click="buscarLetra('D')" class="btn btn-vino-light mr-1">D</button>
                    <button type="button" @click="buscarLetra('E')" class="btn btn-vino-light mr-1">E</button>
                    <button type="button" @click="buscarLetra('F')" class="btn btn-vino-light mr-1">F</button>
                    <button type="button" @click="buscarLetra('G')" class="btn btn-vino-light mr-1">G</button>
                    <button type="button" @click="buscarLetra('H')" class="btn btn-vino-light mr-1">H</button>
                    <button type="button" @click="buscarLetra('I')" class="btn btn-vino-light mr-1">I</button>
                    <button type="button" @click="buscarLetra('J')" class="btn btn-vino-light mr-1">J</button>
                    <button type="button" @click="buscarLetra('K')" class="btn btn-vino-light mr-1">K</button>
                    <button type="button" @click="buscarLetra('L')" class="btn btn-vino-light mr-1">L</button>
                    <button type="button" @click="buscarLetra('M')" class="btn btn-vino-light mr-1">M</button>
                    <button type="button" @click="buscarLetra('N')" class="btn btn-vino-light mr-1">N</button>
                    <button type="button" @click="buscarLetra('O')" class="btn btn-vino-light mr-1">O</button>
                    <button type="button" @click="buscarLetra('P')" class="btn btn-vino-light mr-1">P</button>
                    <button type="button" @click="buscarLetra('Q')" class="btn btn-vino-light mr-1">Q</button>
                    <button type="button" @click="buscarLetra('R')" class="btn btn-vino-light mr-1">R</button>
                    <button type="button" @click="buscarLetra('S')" class="btn btn-vino-light mr-1">S</button>
                    <button type="button" @click="buscarLetra('T')" class="btn btn-vino-light mr-1">T</button>
                    <button type="button" @click="buscarLetra('U')" class="btn btn-vino-light mr-1">U</button>
                    <button type="button" @click="buscarLetra('V')" class="btn btn-vino-light mr-1">V</button>
                    <button type="button" @click="buscarLetra('W')" class="btn btn-vino-light mr-1">W</button>
                    <button type="button" @click="buscarLetra('X')" class="btn btn-vino-light mr-1">X</button>
                    <button type="button" @click="buscarLetra('Y')" class="btn btn-vino-light mr-1">Y</button>
                    <button type="button" @click="buscarLetra('Z')" class="btn btn-vino-light mr-1">Z</button>
                    <button type="button" @click="verTodo()" class="btn btn-vino-light mr-1">Todo</button>
                </div>
            </div>
        </div>
        <!-- Area de de listado vacio, ya que no hay tramite que inicia con esta letra -->
        <div v-if="(letrasFaltantes(letra)) && todos == false" class="no-result text-center" style="background-color:#f7f0f0; padding-top: 1px;">
                <p class="busqueda">Busqueda por la <span class="letra">{{letra}}</span></p>
                <p class="sinResult text-muted">Sin resultados</p>
                <i class="far fa-frown fa-2x"></i>  
        </div>
        <!-- Area listado de tramites por letra seleccionada -->
        <div v-if="data && !todos" style="background-color:#f7f0f0; padding-top: 1px;">
            <div v-if="letra && !(letrasFaltantes(letra)) && todos == false" class="container">
                <p class="busqueda mt-3">Busqueda por la <span class="letra">{{letra}}</span></p>
            </div>  
            <div class="container-tarjetas">
                <stack
                    :column-min-width="300"
                    :gutter-width="15"
                    :gutter-height="15"
                    monitor-images-loaded
                >
                    <stack-item
                    v-for="(tramite, indice) in data" :key="indice"
                    v-if="tramite.nombre.substr(0,1) == letra"
                    style="transition: transform 300ms">
                        <div class="tarjeta-tramite">                                                         
                            <div class="contenedor-nombre_telUrl">
                                <h6 id="nombreTramite">{{tramite.nombre}}</h6>     
                                <!-- Mostrar el telefono si el tramite es Presencial, Teléfonica o En Línea --> 
                                <h6 v-show="tramite.telefono" id="telServicio"><strong>tel. {{tramite.telefono}}</strong> </h6>
                                <!-- Mostrar el campo url si el tramite es en Línea o Presencial o En Línea o Presencial, Teléfonica o En Línea -->
                                <a v-show="tramite.url" :href="tramite.url" target="_blank" id="urlServicio"><strong>{{tramite.url}}</strong></a>    
                            </div>                            
                            <!-- Pintaremos la imagen que le corresponde QUEDA PENDIENTE PONER LA IMAGEN CON EL METODO iconoModalidad() -->
                            <div class="container-img">
                                <h6 id="modalidadServicio">Servicio: <strong>{{tramite.modalidad}}</strong> </h6> 
                                <div class="icono_modalidad">
                                    <img v-show="tramite.modalidad== 'Presencial'" src="@/assets/imagenes/presencial.svg" alt="">
                                    <img v-show="tramite.modalidad== 'En Línea'" src="@/assets/imagenes/linea.svg" alt="">
                                    <img v-show="tramite.modalidad== 'Presencial o En Línea'" src="@/assets/imagenes/presencial-linea.svg" alt="" style="width:38px">
                                    <img v-show="tramite.modalidad== 'Presencial, Teléfonica o En Línea'" src="@/assets/imagenes/presencial-linea-tel.svg" alt="" style="width:38px">
                                </div>
                            </div>
                        </div> 
                    </stack-item>
                </stack>            
            </div> 
                
        </div>
        <!-- Area de listado de TODOS los tramites -->
        <div v-else-if="data && todos" style="background-color:#f7f0f0; padding-top: 20px;">
            <div class="container-tarjetas">
                    <stack
                        :column-min-width="300"
                        :gutter-width="15"
                        :gutter-height="15"
                        monitor-images-loaded>
                        <stack-item
                        v-for="(tramite, indice) in data.slice(0, num)" :key="indice"
                        style="transition: transform 300ms">
                            <div class="tarjeta-tramite">                                             
                                <div class="contenedor-nombre_telUrl">
                                    <h6 id="nombreTramite">{{tramite.nombre}}</h6>     
                                    <!-- Mostrar el telefono si el tramite es Presencial, Teléfonica o En Línea --> 
                                    <h6 v-show="tramite.telefono" id="telServicio"><strong>tel. {{tramite.telefono}}</strong> </h6>
                                    <!-- Mostrar el campo url si el tramite es en Línea o Presencial o En Línea o Presencial, Teléfonica o En Línea -->
                                    <a v-show="tramite.url" :href="tramite.url" target="_blank" id="urlServicio"><strong>{{tramite.url}}</strong></a>    
                                </div>                            
                                <!-- Pintaremos la imagen que le corresponde QUEDA PENDIENTE PONER LA IMAGEN CON EL METODO iconoModalidad() -->
                                <div class="container-img">
                                    <h6 id="modalidadServicio">Servicio: <strong>{{tramite.modalidad}}</strong> </h6> 
                                    <div class="icono_modalidad">
                                        <img v-show="tramite.modalidad== 'Presencial'" src="@/assets/imagenes/presencial.svg" alt="">
                                        <img v-show="tramite.modalidad== 'En Línea'" src="@/assets/imagenes/linea.svg" alt="">
                                        <img v-show="tramite.modalidad== 'Presencial o En Línea'" src="@/assets/imagenes/presencial-linea.svg" alt="" style="width:38px">
                                        <img v-show="tramite.modalidad== 'Presencial, Teléfonica o En Línea'" src="@/assets/imagenes/presencial-linea-tel.svg" alt="" style="width:38px">
                                    </div>
                                </div>
                            </div> 
                        </stack-item>
                    </stack>
                    <center><a id="link-mas" class="link-vino-1" @click="mas()">Ver más</a></center>
            </div>
        </div>
            
        
    </div>
</template>
<script>
import axios from "axios"
import { Stack, StackItem } from "vue-stack-grid";
import Api from "../../services/config/api/axios.urlcontext"

export default {
    components:{
        Stack,
        StackItem
    },
    data:function() {
        return{
            data: null,
            // jsonServicios: Api.APP_URL_API+ "Otros-Recursos/servicios.json",
            todos: true,
            letra: '',
            paginate: ['data'],
            num: 8,
            verDetalleTramite: false,
            idTramite: '',
            token: '',
            cedula: null,
        }
    },
    created: function(){
        // this.proceso('miCombo');
        this.consumoRetys();
        this.selectWidth()
    },
    mounted(){
        // axios
        //     .get(this.jsonServicios)
        //     .then(response => (this.data = response.data))
    },
    methods:{
        selectWidth(){
            if(screen.width < 361){
                console.log('muy pqña');
            }else if(screen.width < 700) {
                console.log('pq'); 
            }else if(screen.width < 1024) {
                console.log('media'); 
            }else if(screen.width < 1280){ 
                console.log('lg'); 
            }else{ 
                console.log('grandota'); 
            }
        },
        proceso(_combo){
            // const UrlServer = this.jsonServicios;
            $("#" + _combo).empty();
                $("#" + _combo).append("<option selected='selected' disabled='disabled'>Ej. Baja de placas de demostración</option>"); 
                $.each(this.data, function (indice, row) {             
                    $("#" + _combo).append("<option value='" + row.idservicio + "'>" + row.nombre + "</option>"); 
                });
                $("#" + _combo).select2({ 
                    placeholder: "",
                    allowClear: false,
                    theme: "bootstrap custom-select",
                    width: this.tamSelect // 900pc 300cel 260celPqño 600tab probar editar valor con metodo disparador / button 2.5rem movil
                 });
        },
        consultarTramite(){
            this.verDetalleTramite = true;
            var tramiteSeleccionado = document.getElementById('miCombo').value;
            this.idTramite = tramiteSeleccionado;
            if(this.idTramite == ''){
                event.preventDefault();
            }
        },

        iconoModalidad(modalidad){
            var icono = "";
            if(modalidad == "Presencial"){
                icono = 'fas fa-user';
            }
            if(modalidad == "En Línea"){
                icono = "@/assets/imagenes/tramitesfondo.jpg";
            }
            if(modalidad == "Presencial o En Línea"){
                icono = "fas fa-chalkboard-teacher";
            }
            if(modalidad == "Presencial, Teléfonica o En Línea"){
                icono = "fas fa-phone";
            }
            return icono;
        },
        buscarLetra(letra){
            console.log('busqueda '+ letra);
            this.todos = false;
            this.letra = letra;
        },
        verTodo(){ // boton ver todos del abcdario
            this.todos = true;
        },
        letrasFaltantes(letra){
            var bandera = false;
            if(this.data){
                if(letra){
                        $.each(this.data, function (index, data) { 
                                if(data.nombre.substr(0,1) == letra){ // compara letra 
                                bandera = true; // si entro, se activa la bandera
                            }
                        });
                        if(bandera == true){
                            return false // falso xq si hay resultados, la letra fue hallada
                        }else{
                            return true; // true para que muestre q no hay resultados
                        }
                }
            }
        },
        mas(){ // enlace de "ver mas"
                var elementos = this.data.length;
                // console.log(elementos + ' | ' + this.num);
                if(this.num <= elementos){
                    this.num = this.num + 8; 
                }else{ // oculto el ver mas
                    document.getElementById("link-mas").className = "link-vino-1 d-none";
                }
            },
        consumoRetys(){
            var mail        = 'hacienda@chiapas.gob.mx';
            var pass        = '#PpIpDxek0H';
            var url         = 'http://api.retys.chiapas.gob.mx/authenticate';
            var token       = '';

            axios.post(url, {
                email: mail,
                password: pass
            })
                .then(response => (this.token = response.data.access_token))
                .catch(function (error) {
                    console.log(error);
            });  

        },
        consumoServicio(){
            var urlServicio = 'http://api.retys.chiapas.gob.mx/servicios?token=';

            axios.post(urlServicio + this.token, {
                iddependencia: '43'
            })
            .then(response => {
                this.data = response.data;
                this.proceso('miCombo');
            })
            .catch(function (error) {
                console.log(error);
            });
            
        },
        obtenerCedula(cedula){
            var ced = cedula;
            var urlCedula   = 'http://api.retys.chiapas.gob.mx/cedula?token=';

            axios.post(urlCedula + this.token, {
                idcedula: ced
            })
            .then(response => (this.cedula = response.data))
            .catch(function (error) {
                console.log(error);
            });

        }
        
        },
    watch:{
        token: function(){
            this.consumoServicio()
        }
    }
        
    
}

</script>

<style scoped>

.busqueda{
    font-size: 1.5rem;
    font-weight: bold;
}
.letra{ color: #90365A; }
.fa-frown{color: #b7c1cabd !important}
.sinResult{ 
    color: #aeb5ba !important;
    font-size: 1.2rem;
    margin-bottom: 0;
}
.no-result{
    margin-top: 3rem !important;
    height:30vh !important;
}
.paginate-links {
    list-style: none !important;
    display: flex;
}
.paginate-links .number {
    margin: auto .5rem !important;
}
.contenedor-tramites .subtitulo2{
        margin-bottom: 0rem !important;
        font-size: .99rem !important;
        font-weight: 500 !important;
    }
    .contenedor-tramites .btn-lupa{
        height: 1.78rem;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        display: flex;
        align-items: center;
    }
    .icono-lupa{
        font-size: 20px;        
    }   
    .caja_busqueda{
        display: flex;
        justify-content: left;
    }
    #miCombo{
        width: 40rem;
    }
    /* ===== AQUI EMPIEZA LOS ESTILOS DE LAS TARJETAS CON LOS TRAMITES ===== */
    .container-tarjetas {
        width: 80vw;
        margin: 0 auto;
        
    }
    .tarjeta-tramite{
        width: 100%;
        height: auto;       
        border-radius: 12px;        
        padding: 0.8rem;
        /* ===opcion1: con la imagen de fondo=== */
        /* background-image: url('../../assets/imagenes/tramitesfondo.jpg');
        background-size: cover !important;
        border: 1px solid #e0dcdc; */

        /* ===Opcion2: sin la imagen de fondo=== */
        background-color: #fefefe;
        border: 2px solid #e0dcdc;
    }
    #nombreTramite{
        
        line-height: 18.9px;
        font-size: 14.5px;
        margin-bottom: 0px;
        /* text-align: justify; */
        /* Alternativa 1 */
        /* color:#621132;
        font-weight: 400; */
        /* Alternativa 2 */
        color: #90365A;
        font-weight: 400;
    }
    #nomDependencia{
        font-size: 14px;
        font-weight: 400;
        margin-top: 1rem;
        margin-bottom: 1.2rem;
        color: #6C757D;
    }
    #modalidadServicio{
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 0px;
        color: #3c4044;
        
    }
    .contenedor-nombre_telUrl{
        line-height: 18px; 
    }
    .contenedor-nombre_telUrl #urlServicio{
        /* Alternativa 1 */
        /* color:#212529;
        text-decoration: underline; */
        /* Alternativa 2 */
        color: #3c4044;
        text-decoration: underline;
        font-weight: 500;
    }
    .contenedor-nombre_telUrl #urlServicio:hover{
        color:#621132 !important;
        
    }
    #telServicio, #urlServicio{
        font-size: 14px;
        font-weight: 400;
        word-wrap: break-word;
        margin-bottom: 0px;
    }

    .container-img{        
        display: flex;
        justify-content: space-between;
        align-items: center;          
    }   
    .icono_modalidad{        
        width: 30px;
    }    
@media only screen and (max-device-width : 1024px){
    .horizontal-scroll-contenedor{
        width: auto;
        height: 35px;
        white-space: nowrap !important;
        overflow-y: hidden; 
        overflow-x: auto;
        margin: .2rem auto;
    }
    /*  ESTILOS PARA MOVIL DE LAS TARJETAS CON LOS TRAMITES */
    .contenedor-tarjetas{
        justify-content: center;
    }
    
}


</style>